export default "__VITE_ASSET__BLWEWl4Y__"